import * as React from 'react';

import { FindAnswersForm } from './find-answers-form';
import { UitkDialogContent, UitkFullscreenDialog, UitkFullscreenDialogTheme } from 'uitk-react-dialog';
import { ToolbarType, UitkToolbar } from 'uitk-react-toolbar';
import { LocalizedText } from 'bernie-l10n';
import { Conversations } from 'components/infosite/conversations';
import { UitkCard, UitkCardContent } from 'uitk-react-cards';
import { inject, observer } from 'mobx-react';
import { CurrentHotelStore } from 'src/common/stores/current-hotel-store';
import { FindAnswersFormLaunchLocation, FindAnswersStore } from 'stores/find-answers-store';
import { ShowAskQuestionForm } from 'components/infosite/find-answers/show-ask-question-form';

export interface FindAnswersTakeoverProps {
  onDismiss: () => void;
  analytics?: {
    setupTracker: (id: string, description: string) => { id; description; callback };
  };
  currentHotel?: CurrentHotelStore;
  findAnswersStore?: FindAnswersStore;
}

interface FindAnswersTakeoverState {
  resultsShown: boolean;
}
@inject('currentHotel', 'findAnswersStore')
@observer
export class FindAnswersTakeover extends React.Component<FindAnswersTakeoverProps, FindAnswersTakeoverState> {
  constructor(props) {
    super(props);
    this.state = {
      resultsShown: false
    };
    this.handleShowResults = this.handleShowResults.bind(this);
  }

  public render() {
    const { analytics, onDismiss, currentHotel, findAnswersStore } = this.props;
    const { resultsShown } = this.state;
    const toolbarAnalytics = analytics.setupTracker(':CancelFindAnwsers', 'Cancel find answers form');
    const toolbarType =
      findAnswersStore &&
      findAnswersStore.formLaunchLocation &&
      findAnswersStore.formLaunchLocation === FindAnswersFormLaunchLocation.REVIEWS_DIALOG
        ? ToolbarType.BACK
        : ToolbarType.CLOSE;
    const questionAnswersViewModel = currentHotel.hotel && currentHotel.hotel.questionAnswersViewModel;
    const enabledForHomeAway = questionAnswersViewModel && questionAnswersViewModel.enabledForHomeAway;
    const enabledForConventionalLodging = questionAnswersViewModel && questionAnswersViewModel.enabledForConventionalLodging;
    const theme = resultsShown ? UitkFullscreenDialogTheme.CANVAS : UitkFullscreenDialogTheme.DEFAULT;

    return (
      <UitkFullscreenDialog dialogShow={true} theme={theme}>
        <UitkToolbar
          header={<LocalizedText message="hotels.infosite.findAnswers.takeover.header" />}
          type={toolbarType}
          analytics={toolbarAnalytics}
          action={onDismiss}
        />
        <UitkDialogContent className="uitk-dialog-content" zeroPadding={true}>
          <UitkCard className="uitk-flat-border-top">
            <UitkCardContent className="all-x-padding-three all-y-padding-three">
              <div className="uitk-cell">
                <FindAnswersForm closeTakeover={onDismiss} onShowResults={this.handleShowResults} />
              </div>
            </UitkCardContent>
          </UitkCard>
          {enabledForHomeAway && (
            <div className="all-x-padding-three all-y-padding-three">
              <Conversations show={resultsShown} />
            </div>
          )}
          {enabledForConventionalLodging &&
            resultsShown && (
              <div className="all-x-padding-three all-y-padding-three">
                <ShowAskQuestionForm show={resultsShown} />
              </div>
            )}
        </UitkDialogContent>
      </UitkFullscreenDialog>
    );
  }

  public handleShowResults() {
    this.setState({
      resultsShown: true
    });
  }
}
